export const ComingSoonCover = ({ children, testid, label = "Coming soon" }) => (
  <div className="relative isolate overflow-hidden" data-testid={testid}>
    <div aria-hidden="true" className="invisible select-none pointer-events-none">
      {children}
    </div>
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-[#0A2333]">
      <div aria-hidden="true" className="absolute inset-3 border border-[#A78558]/40" />
      <p className="relative font-serif italic text-2xl md:text-4xl text-[#F9F8F4] px-8 py-4 text-center">
        {label}
      </p>
    </div>
  </div>
);

export const TopBanner = () => (
  <div
    data-testid="coming-soon-top-banner"
    className="fixed inset-x-0 top-0 z-50 h-8 md:h-10 flex items-center justify-center bg-[#0A2333] text-[#F9F8F4] px-4 text-[9px] md:text-xs uppercase tracking-[0.2em] md:tracking-[0.25em] border-b border-[#A78558]/40"
  >
    <span className="font-serif italic tracking-normal text-[#A78558] normal-case text-sm md:text-base mr-2">
      Coming soon
    </span>
    — this site is being finalised.
  </div>
);
